import React from 'react'

import Loader from '../../assets/icons/loader.svg'

function LoadingOverlay ({ isLoading }) {


  if (isLoading) {

    document.body.style.overflow = 'hidden'

    return (
      <div className='fixed inset-0 z-20 flex justify-center h-screen bg-white opacity-90'>
        <img src={Loader} className='w-1/2' alt="loading" />
      </div>
    )

  } else {

    document.body.style.overflow = 'scroll'

    return <></>

  }

}

export default LoadingOverlay